"use strict";

angular.module("vendor")
.component("businessViewsNav", {
    templateUrl: require("./business-views-nav.component.html"),
    controller: BusinessViewsNavController
});

function BusinessViewsNavController($rootScope, $scope, $resource, appConfig) {
    function updateCounts() {
        var service = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/business-views-partnership-counts/");
        service.get().$promise.then(function(data){
            $scope.partnershipCount = data;
        });
    }

    updateCounts();

    $scope.$on("doResetListing", function(){
        updateCounts();
        $rootScope.UpdateCurrentNumbers();
    });
}



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/business-views-nav/business-views-nav.component.js
// module id = 850
// module chunks = 0